import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormViewer, CustomTitle, Form, FormCreatorService, FormSectionPageComponent, IFormOptions, VisorComponent } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { StepsModule } from 'primeng/steps';
import { FormularioService } from '../../services/formulario.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-form-respuestas',
  standalone: true,
  imports: [VisorComponent, CommonModule, ReactiveFormsModule, StepsModule, CustomTitle, ButtonModule,
    TranslateModule, FormSectionPageComponent
  ],
  providers: [FormCreatorService],
  styleUrl: './../form-viewer/form-viewer.component.scss',
  template: `
  <app-visor/>
  <div *ngIf="this.fc.Pages.length > 1" class="mb-2">
    <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
  </div>

  <div class="form-panel-preview">
    <CustomTitle *ngIf="fc.Form.title" [title]="fc.Form.title" styleClass="font-principal font-20 title-blue border-round
                  ml-1 font-medium px-5 py-3 w-full bg-gray-200" />
    <div class="content formgrid p-fluid">
      <form #form="ngForm" [formGroup]="fc.FormGroup">
        <ng-container *ngIf="fc.activePage">
          <app-form-section-page [page]="fc.activePage" [pageIndex]="fc.activeIndex"
            [formGroup]="fc.getPageFormGroup(fc.activePage.name)" [isDesigner]="isDesigner">
          </app-form-section-page>
        </ng-container>
      </form>
    </div>
    <div class="footer">
      <div>
        <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
          icon="pi pi-angle-left"></p-button>
      </div>
    </div>
  </div>
  `
})
export class FormRespuestasComponent extends BaseFormViewer implements OnInit {

  @Input() options !: IFormOptions;
  radicado ?: string;

  @ViewChild(VisorComponent) visorDialog !: VisorComponent;

  constructor(public override fc: FormCreatorService, private _fs: FormularioService) {
    super(fc);
    this.fc.downloadFileEvent.subscribe(([radicado, fileId, fileName, saveFile]: [string, string, string, boolean]) => {
      this.onDownloadFile(radicado, fileId, fileName, saveFile);
    });
  }

  ngOnInit(): void {
    this.fc.setOptions(this.options);
  }

  public loadForm(formId: number, respuesta?: string): void {
    this._fs.getForm(formId).subscribe({
      next: (response: Form) => {
        this.fc.loadForm(response, this.radicado);
        if (respuesta) {
          this.fc.loadRespuesta(respuesta);
        }
      }
    });
  }

  onDownloadFile(radicado: string, fileId: string, fileName: string, saveFile: boolean) {
    this._fs.downloadFormFile(radicado, fileId).subscribe({
       next: (response: Blob) => {
         if (response.size > 0) {
           if (saveFile)
             saveAs(response, fileName);
           else
             this.visorDialog.showDialog(response);
         }
       }
     });
  }
}
